module.exports = __webpack_public_path__ + "img/851.9e2a72e7.png";